// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-477e349e]{display:none}.az-icon[data-v-477e349e]{display:inline-flex}.az-icon[data-v-477e349e],.az-icon>svg[data-v-477e349e]{height:var(--az-icon-size);width:var(--az-icon-size)}.az-icon>svg path[fill][data-v-477e349e]{fill:var(--az-icon-color)}.az-icon>svg [stroke][data-v-477e349e]{stroke:var(--az-icon-color)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
